export type ReportsWidgetPayload = {
  selectedReport?: ReportItem;
  sortMode?: SortMode;
};
export type ReportItem = {
  report_name: string;
  report_link: string;
  latest_publish_date: string;
  category: string;
};

export type ResearchReport = {
  category: string;
  report: ReportItem[];
};

export type ResearchReportsResponse = ResearchReport[];

export enum SortMode {
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST',
  CATEGORY = 'CATEGORY',
}
